export enum ModalType {
  alert = 'ALERT',
  confirm = 'CONFIRM',
}
